import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLanguage } from "@/context/LanguageContext";

export function FormSpecificStep({ formDefinition, value, onChange }) {
  const { t, lang } = useLanguage();
  if (!formDefinition) return null;
  const fields = formDefinition.specific_fields || [];
  const set = (k, v) => onChange({ ...value, [k]: v });

  return (
    <div className="space-y-6" data-testid="step-form-specific-content">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
          {formDefinition.code}
        </div>
        <h2 className="text-3xl font-black tracking-tight md:text-4xl">
          {t.form_specific.title}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          {t.form_specific.description}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {fields.map((f) => {
          const label = lang === "es" ? f.label_es : f.label_pt;
          const testid = `specific-${f.id}`;
          return (
            <div key={f.id} className={f.type === "checkbox" ? "md:col-span-2" : ""}>
              {f.type === "checkbox" ? (
                <div className="hairline flex items-start gap-3 p-4">
                  <Checkbox
                    id={f.id}
                    data-testid={testid}
                    checked={!!value[f.id]}
                    onCheckedChange={(v) => set(f.id, !!v)}
                  />
                  <Label htmlFor={f.id} className="cursor-pointer text-sm">
                    {label}
                    {f.required && (
                      <span className="ml-1 text-[hsl(var(--warning))]">*</span>
                    )}
                  </Label>
                </div>
              ) : (
                <div className="flex flex-col gap-2">
                  <Label
                    htmlFor={f.id}
                    className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground"
                  >
                    {label}
                    {f.required && (
                      <span className="ml-1 text-[hsl(var(--warning))]">*</span>
                    )}
                  </Label>
                  {f.type === "select" ? (
                    <Select
                      value={value[f.id] || ""}
                      onValueChange={(v) => set(f.id, v)}
                    >
                      <SelectTrigger
                        id={f.id}
                        data-testid={testid}
                        className="h-12"
                      >
                        <SelectValue placeholder="—" />
                      </SelectTrigger>
                      <SelectContent>
                        {(f.options || []).map((opt) => (
                          <SelectItem key={opt} value={opt}>
                            {opt}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  ) : (
                    <Input
                      id={f.id}
                      data-testid={testid}
                      type={f.type === "date" ? "date" : "text"}
                      value={value[f.id] || ""}
                      onChange={(e) => set(f.id, e.target.value)}
                      className="h-12"
                    />
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
